import React from 'react';
import PropTypes from 'prop-types';

import { Field } from 'redux-form';

import CheckboxField from 'components/fields/CheckboxField';

const ProductClaimViewItemSelection = ({ ID, className }) => (
  <div className={className}>
    <Field
      id={`${ID}-orderLine.selected`}
      name={`${ID}-orderLine.selected`}
      component={CheckboxField}
    />
  </div>
);

ProductClaimViewItemSelection.propTypes = {
  ID: PropTypes.number.isRequired,
  className: PropTypes.string,
};

ProductClaimViewItemSelection.defaultProps = {
  className: '',
};

export default ProductClaimViewItemSelection;



// WEBPACK FOOTER //
// ./src/components/workflow/ProductClaimView/ProductClaimViewItemSelection.js